import { render, staticRenderFns } from "./LeadEventDetails.vue?vue&type=template&id=182bd344&scoped=true&"
import script from "./LeadEventDetails.vue?vue&type=script&lang=js&"
export * from "./LeadEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadEventDetails.vue?vue&type=style&index=0&id=182bd344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182bd344",
  null
  
)

export default component.exports